import React from 'react';
import { Form } from 'react-bootstrap';

const FormGroup = ({
  label,
  children,
  requiredField = false,
  error,
  fileName,
}) => {
  return (
    <Form.Group controlId="FormBasicName">
      {label && (
        <Form.Label style={{ paddingTop: "12px", fontSize: "14px",fontWeight:600 }}>
          {label} {requiredField ? <span  style={{color:'#000000',paddingTop:'6px'}}>*</span> : ''}
        </Form.Label>
      )}
          {children}
          {fileName && (
            <div style={{ marginBottom: '8px', fontSize: '12px', color: '#666',marginTop: '5px' }}>
              Current Name: {fileName}
            </div>
          )}
      {error && (
        <Form.Control.Feedback type="invalid" style={{ display: 'block',fontSize:'12px' }}>
          {error}
        </Form.Control.Feedback>
      )}
  </Form.Group>

  );
};

export default FormGroup;
